import { render, staticRenderFns } from "./VirtualScroll.vue?vue&type=template&id=67610892&scoped=true&"
import script from "./VirtualScroll.vue?vue&type=script&lang=js&"
export * from "./VirtualScroll.vue?vue&type=script&lang=js&"
import style0 from "./VirtualScroll.vue?vue&type=style&index=0&id=67610892&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67610892",
  null
  
)

export default component.exports
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';import Ripple from 'quasar/src/directives/Ripple.js';
import Intersection from 'quasar/src/directives/Intersection.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QVirtualScroll});qInstall(component, 'directives', {Ripple,Intersection});
